export default {"src":"/_next/static/image/src/images/amica-one-dark.9815e66a89eb4eaa97f4239772899bce.svg","height":37,"width":199};